export enum CouponEnum {
  AMOUNT = 'AMOUNT',
  PERCENT = 'PERCENT',
  DELIVERY_FREE = 'DELIVERY_FEE_FREE',
  DELIVERY_FEE_AMOUNT = 'DELIVERY_FEE_AMOUNT',
  DELIVERY_FEE_PERCENT = 'DELIVERY_FEE_PERCENT',
  // AMOUNT_TARGET = 'AMOUNT_TARGET',
  // PERCENT_TARGET = 'PERCENT_TARGET',
  // DELIVERY_FREE_TARGET = 'DELIVERY_FREE_TARGET',
  // AMOUNT_PERSONAL = 'AMOUNT_PERSONAL',
  // PERCENT_PERSONAL = 'PERCENT_PERSONAL',
  // DELIVERY_FREE_PERSONAL = 'DELIVERY_FREE_PERSONAL',

}
